import { onboardingStart } from "src/assets";
import {} from "src/api/smartChargingClients";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import { Box, CardMedia, Stack } from "@mui/material";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";

const Start = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  const handleNextClick = () => {
    navigate(SMART_CHARGING_ROUTES.INTRO);
  };

  return (
    <Stack gap={5}>
      <Text
        text={t("page.wallboxOnboardingStart.pageTitle")}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Stack alignItems={"center"}>
        <Box height="120px" width="120px">
          <CardMedia
            component="img"
            alt="start onboarding"
            image={onboardingStart}
            sx={{ objectFit: "contain" }}
          />
        </Box>
      </Stack>

      <Stack gap={1}>
        <Text
          text={t("page.wallboxOnboardingStart.pageSubTitle")}
          sx={(theme) => ({
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            fontFamily: "Inter",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Stack paddingLeft={7} gap={1}>
          <Text
            text={<li>{t("page.wallboxOnboardingStart.point1")}</li>}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: theme.palette.mainFont.primary,
            })}
          />
          <Text
            text={<li>{t("page.wallboxOnboardingStart.point2")}</li>}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: theme.palette.mainFont.primary,
            })}
          />
        </Stack>
      </Stack>

      <Box>
        <PrimaryButton
          onClick={handleNextClick}
          text={t("page.wallboxOnboardingStart.nextBtnText")}
          sx={{ width: { xs: "100%", sm: "fit-content" } }}
        />
      </Box>
    </Stack>
  );
};

export default Start;
